import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../utils.esm.js';

const MyGroupsPickerFieldSchema = makeFieldSchemaFromZod(
  z.string(),
  z.object({
    title: z.string().default("Group").describe("Group"),
    description: z.string().default("A group you are part of").describe("The group to which the entity belongs")
  })
);
const MyGroupsPickerSchema = MyGroupsPickerFieldSchema.schema;

export { MyGroupsPickerFieldSchema, MyGroupsPickerSchema };
//# sourceMappingURL=schema.esm.js.map
